import { PropsWithChildren } from 'react';

import AccountProvider from 'reservations/account/providers/AccountProvider';
import LoadingSpinnerProvider from 'reservations/base/providers/LoadingSpinnerProvider';
import { ModalProvider } from 'reservations/base/providers/ModalProvider';
import QueryProvider from 'reservations/base/providers/QueryProvider';
import MuiThemeProvider from 'reservations/brand/providers/MuiThemeProvider';
import DinerAccountProvider from 'reservations/dinerAccount/providers/DinerAccountProvider';
import { BookingFormProvider } from 'reservations/form/providers/BookingFormProvider';
import PreviewModeProvider from 'reservations/preview/providers/PreviewModeProvider';

const ReservationsProvider = ({ children }: PropsWithChildren) => (
  <QueryProvider>
    <AccountProvider>
      <PreviewModeProvider>
        <MuiThemeProvider>
          <DinerAccountProvider>
            <LoadingSpinnerProvider>
              <ModalProvider>
                <BookingFormProvider>{children}</BookingFormProvider>
              </ModalProvider>
            </LoadingSpinnerProvider>
          </DinerAccountProvider>
        </MuiThemeProvider>
      </PreviewModeProvider>
    </AccountProvider>
  </QueryProvider>
);

export default ReservationsProvider;
